import Alert from '@r1-frontend/ui-react/components/Alert';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';

import { useCtxSelector } from '../hooks';
import getCheckerResult from '../selectors/getCheckerResult';

const ResultMessage = (): JSX.Element | null => {
    const { checked, alertType, message } = useCtxSelector(getCheckerResult);

    if (!checked) {
        return null;
    }

    return <Alert type={alertType}>
        <Paragraph4 dangerouslySetInnerHTML={{ __html: message! }} />
    </Alert>;
};

export default ResultMessage;
